var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Sop.sift"),
        width: "1250px",
        "show-close": false
      }
    },
    [
      _c("approval-search", {
        attrs: {
          status: 0,
          filter: _vm.filter,
          type: _vm.type,
          "document-config-id": _vm.documentConfigId,
          "per-config-name": _vm.perConfigName,
          "grid-refresh-id": _vm.gridRefreshId,
          "expand-adv": true
        },
        on: {
          "update:perConfigName": function($event) {
            _vm.perConfigName = $event
          },
          "update:per-config-name": function($event) {
            _vm.perConfigName = $event
          },
          "update:gridRefreshId": function($event) {
            _vm.gridRefreshId = $event
          },
          "update:grid-refresh-id": function($event) {
            _vm.gridRefreshId = $event
          },
          toQuery: _vm.handleFilter
        }
      }),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.restForm } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }